module.exports = __webpack_public_path__ + "img/from.5b761b62.svg";